const isErrorPage = document.location.pathname === '/error';

if (isErrorPage) {
  document.querySelector('#join-mia-error').style = 'display: flex;';
} else {
  document.querySelector('#join-mia').style = 'display: flex;';
}
